import React from 'react';
import './Section.css';

const Section = ({children, height}) => {
    return (
        <section
            className="section__container"
            style={{ height: height || '' }}
        >
            {children}
        </section>
    );
};

export default Section;